module.exports = __webpack_public_path__ + "static/img/topimage.5da6e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/topimage.png
// module id = obs4
// module chunks = 0